const { getOffsetTop } = window.BAO.Utils

class VideoScrub extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    this.activeIndex = '0'

    this.video = window.BAO.MediaBreakpoints.isSm
      ? this.els['video-desktop'].element
      : this.els['video-mobile'].element

    this.lazyLoadVideos()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
  }

  setupListeners () {
    super.setupListeners()

    this.onSeeked = this.onSeeked.bind(this)

    const videoEl = window.BAO.MediaBreakpoints.isSm
      ? this.els['video-desktop'].element
      : this.els['video-mobile'].element

    this.listeners.add(videoEl, 'seeked', this.onSeeked)

    window.addEventListener('resize', this.configureCanvas.bind(this))
  }

  lazyLoadVideos () {
    for (const source in this.video.children) {
      const videoSource = this.video.children[source]

      if (
        typeof videoSource.tagName === 'string' &&
        videoSource.tagName === 'SOURCE'
      ) {
        videoSource.src = videoSource.dataset.src
      }
    }

    this.video.load()

    this.video.addEventListener(
      'loadedmetadata',
      () => {
        this.configureCanvas()
      },
      { once: true },
    )
  }

  configureCanvas () {
    this.canvas = this.els.canvas?.element
    if (!this.canvas) {
      console.error('Canvas element not found')
      return
    }

    this.canvas.height = this.video.videoHeight
    this.canvas.width = this.video.videoWidth
    this.canvasContext = this.canvas.getContext('2d')

    this.updateEl()
  }

  onSeeked () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.updateVideo()
  }

  updateVideo () {
    if (isNaN(this.video.duration)) {
      return
    }

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint = elementStartPoint + this.offsetHeight

    const videoDuration = Math.floor(this.video.duration)

    if (this.lastKnownY <= elementStartPoint) {
      this.video.currentTime = 0.001
      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.video.currentTime = videoDuration
      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const currentTime = videoDuration * scrollYAsAPercentageOfJourney

    this.video.currentTime = parseFloat(currentTime.toFixed(2))

    this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.canvasContext.drawImage(
      this.video,
      0,
      0,
      this.canvas.width,
      this.canvas.height,
    )
  }
}

if (!customElements.get('video-scrub')) {
  customElements.define('video-scrub', VideoScrub)
}
